module.exports = function isArray(value) {
  if (typeof Array.isArray === "function") {
    return Array.isArray(value)
  } else {
    return Object.prototype.toString.call(value) === "[object Array]"
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/lib/isArray.js